import React, { useState } from 'react';

/* Common */
import { Icon, Image, Modal } from '~/components/common';

/* Icons */
import LabelIcon from '~/../symbols/label.svg';
import StarIcon from '~/../symbols/star.svg';
import ElectricIcon from '~/../symbols/electric.svg';
import EyeIcon from '~/../symbols/eye.svg';
import HeartIcon from '~/../symbols/heart.svg';
import PercentageIcon from '~/../symbols/percentage.svg';
import ExclamationIcon from '~/../symbols/exclamation.svg';
import ShieldIcon from '~/../symbols/shield.svg';
import LeafIcon from '~/../symbols/leaf.svg';
import InfoIcon from '~/../symbols/info.svg';

/* Utilities */
import { getCloudimageUrl } from '~/utilities';

export default function ProductSticker({ sticker, stickerTooltips = {}, ...props }) {
    const [open, setOpen] = useState(false);

    if (!sticker || !sticker.name || !sticker.theme) return null;

    const tooltip = stickerTooltips?.[sticker?.tooltip_id] || null;
    const icons = {
        label: LabelIcon.url,
        leaf: LeafIcon.url,
        star: StarIcon.url,
        electric: ElectricIcon.url,
        eye: EyeIcon.url,
        heart: HeartIcon.url,
        percentage: PercentageIcon.url,
        shield: ShieldIcon.url,
        exclamation: ExclamationIcon.url,
    }

    return (
        <>
            <span className={`badge badge--${sticker.theme} badge--sticker d-flex align-items-center ${tooltip ? 'cursor-pointer' : ''}`} onClick={(e) => { if (tooltip) { e.preventDefault(); setOpen(true); } }}>
                <Icon size={20} url={icons[sticker.icon]} type={sticker.icon} />
                <span className="badge__text">{sticker.name}</span>
                {tooltip ? (
                    <Icon className="text-muted--60" size={16} url={InfoIcon} />
                ) : null}
            </span>
            {tooltip ? (
                <Modal
                    className="modal--sticker"
                    open={open}
                    handleClose={() => setOpen(false)}
                    modalTitle={sticker.name}
                    modalBody={(
                        <div className="row gutters-4 gutters-xl-10">
                            {tooltip.image ? (
                                <div className="col-12 col-xl-6">
                                    <Image
                                        className="img-fluid rounded"
                                        src={getCloudimageUrl(tooltip.image, { w: 540, h: 304, func: 'crop' })}
                                        srcSet={`${getCloudimageUrl(tooltip.image, { w: 1080, h: 608, func: 'crop' })} 2x`}
                                        alt={sticker.name}
                                        width={960}
                                        height={540}
                                        sources={[
                                            {
                                                set: {
                                                    '1x': getCloudimageUrl(tooltip.image, { w: 425, h: 239, func: 'crop' }),
                                                    '2x': getCloudimageUrl(tooltip.image, { w: 850, h: 478, func: 'crop' }),
                                                },
                                                media: '(min-width: 1280px)',
                                            },
                                            {
                                                set: {
                                                    '1x': getCloudimageUrl(tooltip.image, { w: 780, h: 439, func: 'crop' }),
                                                    '2x': getCloudimageUrl(tooltip.image, { w: 1560, h: 878, func: 'crop' }),
                                                },
                                                media: '(min-width: 992px)',
                                            },
                                            {
                                                set: {
                                                    '1x': getCloudimageUrl(tooltip.image, { w: 932, h: 524, func: 'crop' }),
                                                    '2x': getCloudimageUrl(tooltip.image, { w: 1864, h: 1049, func: 'crop' }),
                                                },
                                                media: '(min-width: 768px)',
                                            },
                                            {
                                                set: {
                                                    '1x': getCloudimageUrl(tooltip.image, { w: 708, h: 398, func: 'crop' }),
                                                    '2x': getCloudimageUrl(tooltip.image, { w: 1416, h: 797, func: 'crop' }),
                                                },
                                                media: '(min-width: 600px)',
                                            },
                                        ]}
                                    />
                                </div>
                            ) : null}
                            <div className={`col-12 ${tooltip.image ? 'col-xl-6' : ''}`} dangerouslySetInnerHTML={{ __html: tooltip.text }}></div>
                        </div>
                    )}
                />
            ) : null}
        </>
    );
}
